export default "__VITE_ASSET__05887eb4__"